/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import React from 'react'
import Title from './Title/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Header/Content/No"
  
}) {
  return (<React.Fragment
>
<Title
  viewPath={`${viewPath}/Title`}
/>
{children}
</React.Fragment>)
}